jQuery(function($)
{
    var
        /*
		 * Pseudo-Constants
		 *requestUriReplacePatternPageCategory = '[pageCategory]',
		 *	requestUriReplacePatternSearch = '[search]',
		 */
        /*
		 *requestUriPattern
		 * = '/js_catalog/'
		 * + requestUriReplacePatternPageCategory
		 *+ '/sortings/' + requestUriReplacePatternSearch,
		 */

        // module-global variables
        $body = $('body'),
        $container = $('#custom-filter-options');
    // idLastRequest = 0;

    if (0 === $container.length)
    {
        return;
    }

    /*
	 *function getRequestUri(pageCategory, search) {
	 * return requestUriPattern
	 * .replace(requestUriReplacePatternPageCategory, pageCategory)
	 * .replace(requestUriReplacePatternSearch, search);
	 *}
	 */

    /*
	 *function makeRequestPromise(pageCategory, search) {
	 * var
	 * requestUri = getRequestUri(pageCategory, search),
	 * requestId = idLastRequest + 1,
	 *
	 * request = $.ajax({
	 * 'dataType': 'html',
	 * 'url': requestUri
	 * });
	 *
	 * request.requestId = requestId;
	 * idLastRequest += 1;
	 *
	 * return request;
	 *}
	 */

    function reload()
    {
        console.log('skip sort reload b2b');
        return;
        /*
		 *var
		 * pageCategory = orion.toPageCategory(),
		 * search = document.location.search,
		 *request = makeRequestPromise(pageCategory, search);
		 */

        /*
		 *function handleDone(markup) {
		 * if (idLastRequest !== request.requestId) {
		 * // stale request => discard
		 * return;
		 * }
		 *
		 * $('.sort', $container).remove();
		 * $container.append(markup);
		 *}
		 */

        /*
	 *	orion.startProcessing('#custom-filter-options, .filter-remove-container');
	 * request
	 * .done(handleDone)
	 * .fail(function () {
	 * // console.log("…pagination request failed");
	 * })
	 * .always(function() {
	 * orion.stopProcessing('#custom-filter-options, .filter-remove-container');
	 *});
	 */
    }

    function handleChange(e)
    {
        console.log('filters.sort.js change');
        e.preventDefault();
        var search = $(this).val();				// URL aus Value lesen

        if (window.history.replaceState)
        {
            window.history.replaceState({}, '', search);
            orion.handleLoginRedirectParameter();
        }

        $body.trigger(orion.constants.EventSortCriteriumChanged);
    }

    $container.on('change', '#sort-selection', handleChange);
    $body.on(orion.constants.EventFiltersChanged, reload);
});
